<template>
    <div class="content-container">
        <div class="header">
            <div class="title">Menu</div>
        </div>
        <div class="content nopad">
            <div class="sidebar-menu">
                <ul>
                    <li v-bind:class="selectedNew" v-on:click="$emit('show-content', 'new'); selectNew()"><span class="menutext">NEW MESSAGE</span></li>
                    <li v-bind:class="selectedReceived" v-on:click="$emit('show-content', 'received'); selectReceived()"><span class="menutext">RECEIVED MESSAGES</span></li>
                    <li v-bind:class="selectedSent" v-on:click="$emit('show-content', 'sent'); selectSent()"><span class="menutext">SENT MESSAGES</span></li>                                        
                </ul>
            </div>
        </div>
    </div>
</template>

<script>

    export default {

        data() {
            return {
                currentSelection: 'new'
            }
        },

        computed: {
            selectedNew: function() {
                return this.currentSelection === 'new' ? 'selected' : null;
            },
            selectedReceived: function() {
                return this.currentSelection === 'received' ? 'selected' : null;
            },
            selectedSent: function() {
                return this.currentSelection === 'sent' ? 'selected' : null;
            }
        },

        methods: {
            selectNew: function() {
                this.currentSelection = 'new';
            },
            selectReceived: function() {
                this.currentSelection = 'received';
            },
            selectSent: function() {
                this.currentSelection = 'sent';
            }
        },
        
        mounted() {
            if(this.$route.query.messageId){
                this.$emit('show-content', 'received');
                this.selectReceived();
                this.$emit('go-to-message', this.$route.query.messageId);
            }
        },

    }

</script>